import { Register } from "../components/individual-counseling-project-register/Register";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/* 
個別相談案件登録画面
 */
const IndividualCounselingProjectRegister = () => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.INDIVIDUAL_COUNSELING);

  return (
    <SpaceBetween size="l">
      <Register />
    </SpaceBetween>
  );
};

export default IndividualCounselingProjectRegister;
